const OPEN = '@@Tab/Open';
const CLOSE = '@@Tab/Close';
const CLOSE_OTHERS = '@@Tab/CloseOthers';
const CLOSE_ALL = '@@Tab/CloseAll';
const SELECT = '@@Tab/Select';
const UPDATE = '@@Tab/Update';

const initialState = {};

const getTabState = (state, module) => {
	if (state[module]) {
		return state[module];
	}
	else {
		return {
			tabs: [],
			selected: 0,
			stack: []
		}
	}
};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case OPEN:
			var tab = {
				title: action.title,
				id: Math.random(),
				data: action.data.id,
				unsave: !!action.data.unsave,
				values: action.data.values,
				args: action.data,
				component: action.data.component,
				closable: true
			};
			var st = getTabState(state, action.module);
			st.tabs.push(tab);
			st.selected = tab.id;
			st.stack.push(tab.id);
			state[action.module] = st;
			return {...state};

		case SELECT:
			var st = getTabState(state, action.module);
			st.selected = action.id;
			st.stack.push(action.id);
			state[action.module] = st;
			return {...state};

		case UPDATE:
			state[action.module] = getTabState(state, action.module);
			var tab = state[action.module].tabs.filter(item => action.id == item.id)[0];
			if (tab) {
				let index = state[action.module].tabs.indexOf(tab);
				state[action.module].tabs[index] = {...tab, ...action.tab};
				state[action.module].tabs = [...state[action.module].tabs];
			}
			return {...state};

		case CLOSE:
			state[action.module] = getTabState(state, action.module);
			state[action.module].tabs = state[action.module].tabs.filter(item => action.id != item.id);
			if (state[action.module].selected == action.id) {
				state[action.module].stack.pop();
				let lastid = state[action.module].stack.pop();
				let exists = state[action.module].tabs.filter(item => lastid == item.id).length > 0;
				while (!exists && state[action.module].stack.length > 0) {
					lastid = state[action.module].stack.pop();
					exists = state[action.module].tabs.filter(item => lastid == item.id).length > 0;
				}
				state[action.module].selected = exists ? lastid : 0;
			}
			return {...state};

		case CLOSE_OTHERS:
			state[action.module] = getTabState(state, action.module);
			state[action.module].selected = action.id;
			state[action.module].tabs = state[action.module].tabs.filter(item => action.id == item.id);
			return {...state};

		case CLOSE_ALL:
			state[action.module] = getTabState(state, action.module);
			state[action.module].selected = 0;
			state[action.module].stack = [];
			state[action.module].tabs = [];
			return {...state};

		default:
			return state;
	}
}


export function openTabForm(module, title, data) {
	return {
		type: OPEN,
		module,
		title,
		data,
		url: '/' + module + '/' + data.id
	};
}

export function selectTab(module, id) {
	return {
		type: SELECT,
		url: (state) => {
			const tab = state.tabs[module].tabs.filter((item) => item.id == id)[0];
			return '/' + module + (tab ? '/' + tab.data : '');
		},
		module,
		id
	};
}

export function closeTab(module, id) {
	return {
		type: CLOSE,
		module,
		id,
		url: (state) => {
			const selected = state.tabs[module].selected;
			const tab = state.tabs[module].tabs.filter((item) => item.id == selected)[0];
			return '/' + module + (tab ? '/' + tab.data : '');
		}
	};
}

export function closeOthersTab(module, id) {
	return {
		type: CLOSE_OTHERS,
		module,
		id
	};
}

export function closeAll(module, id) {
	return {
		type: CLOSE_ALL,
		module,
		id
	};
}

export function updateTab(module, id, tab) {
	return {
		type: UPDATE,
		module,
		tab,
		id
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/tabs.js